import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Card } from 'antd';
import { type IReference } from '../../../expressions/references/IReference.ts';
import { type IAsyncService } from '../../../expressions/repository/async/context/IAsyncService.ts';
import { AsyncServiceInputsInput } from '../../../expressions/repository/async/input/AsyncServiceInputsInput.tsx';

export interface IExternalServiceConfigFormProps {
  name: string;
  selected: IAsyncService;
  references: IReference[];
}

export function ExternalServiceConfigForm(
  props: IExternalServiceConfigFormProps,
) {
  const { name, selected, references } = props;
  return (
    <Card size="small" title="Configura Servizio">
      {/* <h4>Configura Servizio</h4> */}
      <FormItem
        name={`${name}.inputs`}
        label="Input"
        layout={{ removeHelpMargin: true }}
      >
        <AsyncServiceInputsInput
          style={{ minWidth: '200px', width: '100%' }}
          name={`${name}.inputs`}
          service={selected}
          references={references}
          size="large"
        />
      </FormItem>
    </Card>
  );
}
